module.exports = __webpack_public_path__ + "static/media/meteor.73bbff22.svg";